import { useCreate } from '../../../api';

export const useUpdateLetter = (id: string, msg?: string) => {
  const {
    mutateAsync: updateLetter,
    isLoading: isUpdatingLetter,
    error,
  } = useCreate({
    url: `letter-generation/employees/letter-requests/${id}`,
    customInvalidateQueriesUrl: 'letter-generation/employees/letter-requests',
    msg,
  });

  return {
    isUpdatingLetter,
    error,
    updateLetter,
  };
};
